import React from "react";
import { FaLayerGroup, FaLightbulb, FaUserCheck } from "react-icons/fa";

function BenefitsOfPartnering() {
  return (
    <>
      <div
        className="process-style-two-area overflow-hidden bg-cover default-padding bg-dark text-light"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-20.jpg)",
        }}
      >
        <div className="container">
          <div className="site-heading">
            <div className="row align-center">
              <div className="col-lg-6">
                <h4 className="sub-title">Our Process</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Benefits of Partnering With Xeer Technology for NFT Collection
                  Launch
                </h2>
              </div>
              <div className="col-lg-5 offset-lg-1">
                <p>
                  Partnering with Xeer Technology for your NFT collection launch
                  offers a range of advantages that ensure your project stands
                  out in the competitive digital space. Our end-to-end
                  development process covers everything from initial concept to
                  post-launch support, ensuring a smooth and successful launch.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="process-style-two-items">
            <div className="row">
              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item ">
                  <div className="icon-one pb-4">
                    <FaLayerGroup size={40} />
                  </div>
                  <h4>End-to-End Development</h4>
                  <p>
                    From conceptualizing your NFT collection to the technical
                    launch and post-launch support, we handle every aspect of
                    the development process.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item ">
                  <div className="icon-one pb-4">
                    <FaLightbulb size={40} />
                  </div>
                  <h4>Creative & Technical Expertise</h4>
                  <p>
                    Our team consists of experienced blockchain developers and
                    talented digital artists who bring innovation and creativity
                    to your NFT collection.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item ">
                  <div className="icon-one pb-4">
                    <FaUserCheck size={40} />
                  </div>
                  <h4>User-centric Approach</h4>
                  <p>
                    We focus on user-friendly design, ensuring that both
                    creators and buyers can engage with your collection
                    effortlessly.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BenefitsOfPartnering;

// import React from "react";
// import { FaLayerGroup, FaLightbulb, FaUserCheck } from "react-icons/fa";

// function BenefitsOfPartnering() {
//   const benefits = [
//     {
//       icon: <FaLayerGroup />,
//       title: "End-to-End Development",
//       desc: "From conceptualizing your NFT collection to launch and post-launch support, we handle everything.",
//     },
//     {
//       icon: <FaLightbulb />,
//       title: "Creative & Technical Expertise",
//       desc: "Our team combines blockchain expertise with creative innovation to deliver standout NFT projects.",
//     },
//     {
//       icon: <FaUserCheck />,
//       title: "User-centric Approach",
//       desc: "We design experiences that are intuitive and engaging for both creators and users.",
//     },
//   ];

//   return (
//     <div
//       className="process-style-two-area overflow-hidden bg-cover default-padding bg-dark text-light"
//       style={{
//         backgroundImage:
//           "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-20.jpg)",
//       }}
//     >
//       <div className="container">
//         {/* Heading */}
//         <div className="site-heading">
//           <div className="row align-center">
//             <div className="col-lg-6">
//               <h4 className="sub-title">Our Process</h4>
//               <h2 className="title">
//                 Benefits of Partnering With Xeer Technology for NFT Collection
//                 Launch
//               </h2>
//             </div>
//             <div className="col-lg-5 offset-lg-1">
//               <p>
//                 Partnering with Xeer Technology ensures a smooth NFT launch with
//                 full support from concept to deployment.
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="container">
//         <div className="">
//           <div className="row">
//             {benefits.map((item, index) => (
//               <div className="col-lg-4 col-md-6 " key={index}>
//                 <div className=" text-center">
//                   {/* ICON (Replaces 01, 02, 03) */}
//                   <div className="icon-box mx-auto mb-3">{item.icon}</div>

//                   <h4>{item.title}</h4>
//                   <p>{item.desc}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Styles */}
//       <style>{`
//         .icon-box {
//           width: 70px;
//           height: 70px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           background: rgba(255,255,255,0.1);
//           color: #fff;
//           border-radius: 20px;
//           font-size: 26px;
//           transition: 0.3s;
//         }

//         .process-style-two-item:hover .icon-box {
//           background: #3b82f6;
//           transform: scale(1.1);
//         }
//       `}</style>
//     </div>
//   );
// }

// export default BenefitsOfPartnering;
